import { PaymentOperation, PaymentOperationJSON } from "./payment-operation";

export class PaymentOperationFactory {
  static toEntity(json: PaymentOperationJSON): PaymentOperation {
    return new PaymentOperation(
      json.paymentTransactionType,
      json.paymentId,
      json.amount,
      json.items,
      json.createdAt,
    );
  }

  static toEntityArray(
    json: PaymentOperationJSON[] | null,
  ): PaymentOperation[] {
    if (!json) {
      return [];
    }
    return json.map(PaymentOperationFactory.toEntity);
  }
}
